import { notify } from "@/helpers/$vs.js";
import isBase64 from "is-base64";

export default {
  capitalize(_string) {
    return _string.charAt(0).toUpperCase() + _string.slice(1);
  },

  cutString(longStr, max = 20) {
    const maxChar = max;

    if (longStr.length >= maxChar) {
      return `${longStr.slice(0, maxChar)}...`;
      // return longStr.substring(0, maxChar) + '...';
    }
    return longStr;
  },

  isMail(string) {
    const expresion =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (expresion.test(string)) {
      return true;
    } else {
      return false;
    }
  },
  isUrl(string) {
    const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;

    const localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
    const nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

    if (typeof string !== "string") {
      return false;
    }

    const match = string.match(protocolAndDomainRE);
    if (!match) {
      return false;
    }

    const everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) {
      return false;
    }

    if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) {
      return true;
    }

    return false;
  },
  isIp(ip) {
    const regex = new RegExp(
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
    );
    const ipTrim = ip.toString().trim();

    return regex.test(ipTrim);
  },
  isBase64(string) {
    const base64 = string.split(",")[1];
    return isBase64(base64);
  },
  validateUrl(url, title = "Danger") {
    var pattern = new RegExp(/^(https)\:\/\/[a-z0-9\.-]+\.[a-z]{2,4}/gi);
    const _url = url;

    if (!!!pattern.test(_url)) {
      notify(title, "No es una url válida o no contiene protocolo https.", "danger");
      return false;
    } else {
      const url = new URL(_url);
      if (!(url.protocol === "https:")) {
        notify(title, "La url debe contener protocolo de seguridad https.", "danger");
        return false;
      }
    }
    return true;
  },

  allowed_extension() {
    return ["jpg", "jpeg", "png", "gif", "bmp", "pdf", "txt", "csv", "xls", "xlsx"];
  },

  checkExt(filename) {
    const extensions = this.allowed_extension();
    let nameFile = filename.name;
    nameFile = nameFile.toLowerCase();
    const ext = nameFile.substr(nameFile.lastIndexOf(".") + 1);
    const isValid = extensions.indexOf(ext) > -1;
    return { valid: isValid, ext };
  },

  genders(url, method, data, onSuccess, onError) {
    return [
      { id: 1, name: "Male" },
      { id: 2, name: "Female" },
      { id: 3, name: "Other" }
    ];
  },

  generateDonwloadFile(data, type, fileName) {
    const oMyBlob = new Blob([data], { type });
    const url = URL.createObjectURL(oMyBlob);
    const element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("download", fileName);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    return url;
  },

  urlDataStudio(url) {
    const datastudio =
      /https\:\/\/\bdatastudio\.google\.com\b\/embed\/reporting\/[a-z,A-Z,0-9]{8}\-[a-z,A-Z,0-9]{4}\-[a-z,A-Z,0-9]{4}\-[a-z,A-Z,0-9]{4}\-[a-z,A-Z,0-9]{12}/;
    const extension = /\/page\/[a-z,A-Z,0-9]{5}$\b/;

    if (extension.test(url)) {
      const join = new RegExp(datastudio.source + /\b/.source + extension.source);
      if (join.test(url)) {
        return true;
      }
    } else {
      const sinExtension = new RegExp(datastudio.source + /$\b/.source);
      if (sinExtension.test(url)) {
        return true;
      }
    }

    return false;
  }
};
